import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SnapshotService } from '../../../../services/core.snapshot.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';

@Component({
    selector: 'project-admin-snapshot-delete-modal',
    template: require('./project.admin.snapshot.delete.modal.html')
})
export class ProjectAdminSnapshotDeleteModalComponent implements OnInit {
    @Input() snapshotId: string;
    @Input() snapshotName: string;

    @Output() onClose = new EventEmitter<boolean>();
    
    deleting = false;

    constructor(
        private snapshotService: SnapshotService,
        private uiService: UiService,
        private translateService: GfTranslateService
    ) {}

    ngOnInit(): void {
    }

    doDeleteSnapshot(): void {
        this.deleting = true;
        this.snapshotService.delete(this.snapshotId).then(
            (response: any) => {
                if (response && response.succeeded) {
                    this.uiService.message.showSuccess(
                        this.translateService.translate('Snapshot {{id}} was deleted', { id: this.snapshotId }),
                        this.snapshotId
                    );
                    this.onClose.emit(true);
                } else {
                    this.uiService.message.showWarning(
                        this.translateService.translate('The snapshot file was NOT deleted. Permission was denied by the server.'),
                        this.snapshotId
                    );
                    this.onClose.emit(false);
                }
            },
            error => {
                const errorMessage = error?.message || 'An error occurred while deleting the snapshot.';
                this.uiService.message.showError(errorMessage);
                this.onClose.emit(false);
            }
        ).finally(() => {
            this.deleting = false;
        });
    }

    closeModal(): void {
        this.onClose.emit(false);
    }
}